import { Injectable, Inject } from '@angular/core';
import { Base } from "./base";
import { InvestorFile as T } from '../Interfaces';

@Injectable()
export class InvestorFile extends Base implements T {
    file_id: number;
    id: number;
    investor_id: number;
    name: string;
    url: string;
    type: string;
    extension: string;
    category: string;
    data: any;
    static docs = ['pdf'];
    static pics = ['png', 'jpg', 'jpeg'];
    constructor(json?: (T | any)) {
        super(json);
        if (!this.id) this.id = this.file_id;
        if (typeof this.data == 'string') {
            this.data = `${this.data}${this.url}${this.name}`;
        }
    }
    getContentUrl() {
        if (this.data instanceof Blob) {
            // code to execute to download file from API
        }
        // code to execute when getting file from ftp server link
        return this.data;

    }
    isDoc() {
        return InvestorFile.docs.includes(this.extension);
    }
    isImage() {
        return InvestorFile.pics.includes(this.extension);
    }
    // code to execute when we have file binary data instead of a link
    protected constructBlobLink() { }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/_models/Classes/investor-file.ts